import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiFetch } from './client';

export interface SetupConfig {
  setupCompleted: boolean;
}

export function useSetupConfig() {
  return useQuery({
    queryKey: ['system', 'setup-completed'],
    queryFn: () => apiFetch<SetupConfig>('/system/setup-completed'),
  });
}

export function useSetSetupCompleted() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (setupCompleted: boolean) =>
      apiFetch<SetupConfig>('/system/setup-completed', {
        method: 'POST',
        body: JSON.stringify({ setupCompleted }),
      }),
    onSuccess: (data) => {
      qc.setQueryData(['system', 'setup-completed'], data);
    },
    onError: (e: Error) => toast.error(e.message),
  });
}
